<template>
  <section class="page-section about-page" data-page="1">
    <div class="page-container">
      <h2 class="page-title">
        <span class="title-highlight">关于我们</span>
        <span class="title-subtitle">About Us</span>
      </h2>
      
      <div class="about-content-vertical">
        <!-- 文字介绍部分 -->
        <div class="about-text-section">
          <div class="intro-header">
            <h3>{{ companyInfo.title }}</h3>
            <div class="intro-tags">
              <span class="tag" v-for="tag in companyInfo.tags" :key="tag">{{ tag }}</span>
            </div>
          </div>
          
          <div class="intro-highlights-compact">
            <div class="highlight-item" v-for="highlight in highlights" :key="highlight.title">
              <div class="highlight-icon">{{ highlight.icon }}</div>
              <div class="highlight-text">
                <strong>{{ highlight.title }}</strong>
                <p>{{ highlight.description }}</p>
              </div>
            </div>
          </div>
          
          <div class="company-mission-compact">
            <div class="mission-icon">💎</div>
            <div class="mission-content">
              <h4>核心使命</h4>
              <p>{{ companyInfo.mission }}</p>
            </div>
          </div>
        </div>

        <!-- 图片展示部分 -->
        <div class="about-image-section">
          <div class="image-container">
            <img 
              :src="imageData.lowQuality" 
              alt="关于我们图片" 
              class="about-image"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection',
  props: {
    imageData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      companyInfo: {
        title: '遗产保护领域的专业团队',
        tags: ['数字化保护', '技术创新', '文化传承'],
        mission: '我们矢志成为遗产数据价值转化的关键推动者，助力历史瑰宝在数字时代绽放全新光彩。'
      },
      highlights: [
        {
          icon: '🏛️',
          title: '专业背景与技术积淀',
          description: '本公司拥有深厚的文化遗产数字化保护领域背景与技术积淀。我们植根于精准数字化技术与严谨考古研究的深度融合，以面向文物保护、研究与利用的数字化技术为核心发展方向，是文物高保真数字化保护领域的专业团队。'
        },
        {
          icon: '🔬',
          title: '前沿技术集群应用',
          description: '基于深厚的技术与实践基础，我们积极拥抱计算机技术、人工智能、信息技术、大数据、区块链等前沿数字技术集群。我们的核心使命聚焦于遗产数据的科学管理与活化利用。'
        },
        {
          icon: '🚀',
          title: '数据赋能平台建设',
          description: '我们致力于构建一个强大的文化遗产数据赋能平台，不仅提供数据的高精度采集与安全管理，更专注于深度挖掘其内在价值。我们的目标是为遗产数据的全场景应用提供全流程、全方位的支持与服务，连接历史智慧与现代产业，探索遗产可持续传承与创新发展的新路径。'
        }
      ]
    };
  }
};
</script>

<style scoped>
.about-page {
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  color: white;
}

.about-content-vertical {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  height: 70%;
}

/* 文字介绍部分 */
.about-text-section {
  width: 100%;
}

.intro-header h3 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 15px;
  background: linear-gradient(135deg, #ffffff 0%, #e0f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.3;
  text-align: center;
}

.intro-tags {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 30px;
}

.tag {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(147, 51, 234, 0.2) 100%);
  color: #ffffff;
  padding: 6px 14px;
  border-radius: 18px;
  font-size: 0.8rem;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.intro-highlights-compact {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 15px;
  margin-bottom: 25px;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
}

.highlight-item:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

.highlight-icon {
  font-size: 1.3rem;
  min-width: 32px;
  text-align: center;
}

.highlight-text strong {
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  margin-bottom: 4px;
  color: #ffffff;
}

.highlight-text p {
  font-size: 0.85rem;
  line-height: 1.4;
  margin: 0;
  opacity: 0.9;
}

.company-mission-compact {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(147, 51, 234, 0.15) 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 800px;
  margin: 0 auto;
}

.mission-icon {
  font-size: 1.8rem;
  min-width: 45px;
  text-align: center;
}

.mission-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
  color: #ffffff;
}

.mission-content p {
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;
  opacity: 0.95;
}

/* 图片展示部分 */
.about-image-section {
  width: 100%;
  display: flex;
  justify-content: center;
}

.image-container {
  max-width: 800px; /* 从600px增加到800px */
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border: 2px solid rgba(255, 255, 255, 0.1);
}

.about-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.image-container:hover .about-image {
  transform: scale(1.02);
}

@media (max-width: 1024px) {
  .about-content-vertical {
    gap: 30px;
  }
  
  .intro-header h3 {
    font-size: 1.4rem;
  }
  
  .intro-highlights-compact {
    grid-template-columns: 1fr;
  }
  
  .company-mission-compact {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .image-container {
    max-width: 90%; /* 在平板设备上也适当增大 */
  }
}

@media (max-width: 768px) {
  .intro-tags {
    gap: 8px;
  }
  
  .tag {
    padding: 4px 10px;
    font-size: 0.75rem;
  }
  
  .highlight-item {
    padding: 12px;
  }
  
  .company-mission-compact {
    padding: 15px;
  }
  
  .image-container {
    max-width: 100%; /* 手机端保持全宽 */
  }
}
</style>